import { Component, Inject, Optional, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { WindowState } from '@progress/kendo-angular-dialog';
import { GridFieldSummary } from '~/models/modules/gridField';
import { SharedService } from '~/services/sharedService';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';

@Component({
    selector: 'app-report-viewer-popup',
    templateUrl: './popup.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ReportViewerPopupComponent {
  windowState: WindowState = 'default';
  _active: boolean = true;
  windowMode: boolean;
  reportId: number;
  selectedReportFields: GridFieldSummary[];
  showFilter: boolean = false;
  showEmail: boolean = false;
  siteId: number = null;
  transactionId: any;
  maximized: boolean;

  constructor(private _sharedService: SharedService,
    private _layoutManager: LayoutManagerService,
    @Optional() private _layoutComponent: LayoutComponent,
    @Inject(PORTAL_DATA) public data: any) {
    this._getDialogModel();

    if (data?.model) {
      this.reportId = data.model.reportId ?? this.reportId;
      this.selectedReportFields = data.model.selectedReportFields ?? this.selectedReportFields;
      this.transactionId = data.model.transactionId ?? this.transactionId;
      this.showFilter = data.model.showFilter ?? this.showFilter;
      this.showEmail = data.model.showEmail ?? this.showEmail;
      this.siteId = data.model.siteId ?? this.siteId;
    }
  }

  _getDialogModel() {
    this.reportId = this._sharedService.model?.model?.reportId;
    this.selectedReportFields = this._sharedService.model?.model?.selectedReportFields;
    this.showFilter = this._sharedService.model?.model?.showFilter;
    this.showEmail = this._sharedService.model?.model?.showEmail;
    this.transactionId = this._sharedService.model?.model?.transactionId;
    this.siteId = this._sharedService.model?.model?.siteId;
    this.windowMode = true;
    this._layoutManager.applyOverly();
  }

  _onCancel() {
    this._closeForm();
  }

  _closeForm() {
    var closeComponent = { component: 'reportViewer', isClosed: true };

    this._active = false;
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
  }

  maximizeWindow() {
    this.windowState = 'maximized';
    this.maximized = true;
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
    this._layoutComponent?.detachDialogForm();
  }

  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    }
    else {
      this._layoutManager.applyOverly();
    }
  }
}
